import { LoginForm } from './LoginForm';

/** /staff/login */
export function StaffLoginPage() {
  return <LoginForm audience="staff" home="/staff" forgotTo="/staff/forgot-password" />;
}
